export default "__VITE_ASSET__B3DFGfpj__"